/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://assets.twilio.com/public_assets/try-twilio/1.18.4/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
__webpack_require__(2);
__webpack_require__(3);
__webpack_require__(4);
module.exports = __webpack_require__(5);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This app sends AJAX as JSON, note it needs to set two attributes to do that:
 * - contentType so jQuery knows it's Json and does the right thing
 * - dataType so twilio-specific CSRF handling doesn't mangle your payload
 * see for more info https://code.hq.twilio.com/react/console-js/pull/96
 */

var __init__twilio = true;

$(function () {
    // create Arkose trigger element
    var $startArkose = $('#start-arkose');
    var isArkoseOn = $startArkose.length > 0;
    var $registrationFrom = $('@registration-form');
    var $signupButton = $('#signup-button');
    var csrfToken = $('meta[name=csrfToken]').attr('content');
    var $passwordGuidelines = $('#password-guidelines');
    var $emailAddr = $('#EmailAddr');
    var $partner = $registrationFrom.find('input[name="partner"]');
    var $preferredLanguage = $('#preferredLanguage');
    // password requirements div only exists if the user is in the password experiment
    var $isPasswordApiEnforced = $('#password-requirements').length > 0;
    // Time in ms to wait to see if Arkose finished loading.
    var ARKOSE_WAIT_TIME = 10 * 1000;

    function arkoseBabysitter() {
        function sendSignupAlert() {
            var data = {
                'message': 'arkose-timeout-enable-submit',
                'email': $emailAddr.val()
            };
            $.ajax({
                url: '/signup/v2/alert',
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                headers: {
                    'X-Twilio-Csrf': csrfToken,
                    'x-target-region': 'us1'
                },
                method: "POST"
            });
        }
        function didArkoseFail() {
            return $signupButton.attr('disabled') == 'disabled';
        }
        window.setTimeout(function () {
            if (didArkoseFail()) {
                sendSignupAlert();
            }
        }, ARKOSE_WAIT_TIME);
    }

    if (!$preferredLanguage.attr("value")) {
        if (window.location.hostname === 'jp.twilio.com') {
            $preferredLanguage.val('ja');
        } else {
            $preferredLanguage.val('en');
        }
    }

    /**
     * Setup the dropdown for selecting programming languages
     */
    $('#ProgrammingLanguage').selectize({
        create: false,
        placeholder: 'Choose your language'
    });

    var twilio = window.twilio || {};

    twilio.registrationForm = {
        validate: function validate() {
            twilio.analytics.event('/try-twilio', {
                'url': window.location.pathname
            });

            var baseValidationRules = {
                FirstName: {
                    required: true,
                    minlength: 1
                },
                LastName: {
                    required: true,
                    minlength: 1
                },
                EmailAddr: {
                    required: true,
                    email: true,
                    minlength: 1,
                    remote: {
                        url: '/console/funnel/api/email-check',
                        type: 'post',
                        data: {
                            partner: function partner() {
                                return $partner.val();
                            }
                        },
                        headers: {
                            'X-Twilio-Csrf': csrfToken,
                            'x-target-region': 'us1'
                        },
                        dataFilter: function dataFilter(respData, type) {
                            var parsedData = JSON.parse(respData);
                            var status = parsedData.status ? parsedData.status : null;
                            var statusToError = {
                                'occupied': 'This address is already registered <a href="/login" class="link-block">Log In</a>',
                                'forbidden_by_org': 'Your Organization Administrator must invite you.',
                                'organization_limit': 'Your Organization has reached its limit, ' + 'please contact your Organization administrator.'
                            };
                            var message = statusToError[status];
                            if (message) {
                                return JSON.stringify(message);
                            }
                            return true;
                        }
                    }
                },
                Passwd: {
                    required: true,
                    minlength: 1,
                    remote: {
                        depends: function depends() {
                            return $isPasswordApiEnforced;
                        },
                        param: {
                            url: '/signup/v2/password-check',
                            type: 'post',
                            headers: {
                                'X-Twilio-Csrf': csrfToken,
                                'x-target-region': 'us1'
                            },
                            dataFilter: function dataFilter(respData, type) {
                                var parsedData = JSON.parse(respData);
                                var success = parsedData.success ? parsedData.success : null;
                                var errorMessages = void 0;
                                if (!success) {
                                    var errors = parsedData.errors ? parsedData.errors : [];
                                    errorMessages = $("<ul>").append(errors.map(function (err) {
                                        return $("<li>").text(err["devMessage"]);
                                    }))
                                    // turns the jquery element into a string while preserving the outer <ul> element
                                    .prop("outerHTML");
                                }

                                if (errorMessages) {
                                    return JSON.stringify(errorMessages);
                                }

                                return true;
                            }

                        }
                    }
                },
                Tos: {
                    required: true
                }
            };

            var messages = {
                FirstName: { required: 'Required', minlength: 'Required' },
                LastName: { required: 'Required', minlength: 'Required' },
                EmailAddr: {
                    required: 'Required',
                    email: 'Enter a valid email'
                },
                Passwd: {
                    required: 'Required',
                    minlength: 'Please enter at least ' + baseValidationRules['Passwd'].minlength + ' characters'
                },
                ProductInterest: { required: 'Required' },
                UseCase: { required: 'Required' },
                ProgrammingLanguage: { required: 'Required' },
                EstimatedUsageOptions: { required: 'Required' },
                Tos: { required: 'You must accept the Terms of Service to create a Twilio Account' }
            };

            /**
             * Validation will not occur on 'EmailAddr' and 'Passwd' elements on key typing events.
             * We only want to validate when the field loses focus.
             */
            var onkeyup = function onkeyup(element) {
                if ($(element).attr('id') !== 'EmailAddr' && $(element).attr('id') !== 'Passwd') {
                    this.element(element);
                }
            };

            var errorPlacement = function errorPlacement(error, element) {
                var $el = $(element);

                if ($el.is('select')) {
                    var divElement = $el.parent().find('div.selectize-control');

                    if (divElement.length) {
                        error.insertAfter(divElement[0]);
                    }
                    return;
                }

                if ($el.is('#Tos')) {
                    var _divElement = $el.parent().find('span.help-block');
                    _divElement.replaceWith(error);
                    return;
                }

                if (element.next().is('span.help-block')) {
                    element.next().replaceWith(error);
                } else {
                    error.insertAfter(element);
                }
            };

            var highlight = function highlight(element) {
                $(element).parent().addClass('has-error');
            };

            var unhighlight = function unhighlight(element) {
                var $el = $(element);
                var hasErrors = $el.attr('id') in this.errorMap;

                if (!hasErrors) {
                    $el.parent().removeClass('has-error').find('.help-block').html('');
                }

                if ($el.is('[name="Passwd"]')) {
                    $passwordGuidelines.hide();
                }
            };

            var ignorePattern = ':hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input';

            $registrationFrom.validate({
                rules: baseValidationRules,
                messages: messages,
                errorElement: 'span',
                errorClass: 'help-block m-b-0',
                errorPlacement: errorPlacement,
                onkeyup: onkeyup,
                highlight: highlight,
                unhighlight: unhighlight,
                ignore: ignorePattern
            });
        },

        registerHandlers: function registerHandlers(onSubmit) {
            var regFormEl = document.getElementById("registration-form");
            regFormEl.addEventListener("submit", function (e) {
                e.preventDefault();
                twilio.alert.clear();

                if ($registrationFrom.valid()) {
                    onSubmit ? onSubmit() : twilio.registrationForm.postData();
                } else {
                    $signupButton.button('reset');
                }
            });
        },

        postData: function postData() {
            var addData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            twilio.alert.clear();

            function onError(data) {
                var errorMessage = 'An error occurred during signup.\n                    Please contact <a href=\'mailto:help@twilio.com\'>\n                    help@twilio.com</a> if you are unable to continue.';
                var sanitized = true;

                try {
                    // Not all failures will have an error message.
                    errorMessage = data.responseJSON.message.message;
                    sanitized = false;
                } catch (e) {
                    // nothing, safe to fail
                }

                twilio.alert.new('error', errorMessage, false, { clear: true, sanitized: sanitized });

                $signupButton.removeAttr('disabled').removeClass('disabled').val('Get Started').text('Get Started');
            }

            function onSuccess(data) {
                twilio.analytics.pageView('/user/welcome');
                window.location = data.location ? data.location : '/signup/verify';
            }

            var rawData = $registrationFrom.serializeArray();
            var formData = rawData.reduce(function (memo, item) {
                memo[item.name] = item.value;
                return memo;
            }, {});

            formData['CSRF'] = csrfToken;
            formData['Referer'] = document.referrer;

            var postData = Object.assign(formData, addData);

            $.ajax({
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                url: $registrationFrom.attr('action'),
                data: JSON.stringify(postData),
                headers: {
                    'X-Twilio-Csrf': csrfToken,
                    'x-target-region': 'us1'
                },
                success: onSuccess,
                error: onError
            });
        },

        ready: function ready() {
            $signupButton.removeAttr('disabled');
        },

        reset: function reset(response) {
            $signupButton.button('reset');
        }
    };

    var registrationFormEnforcement = {
        setup: function setup() {
            window.setupEnforcement = function (enforcement) {
                enforcement.setConfig({
                    selector: '#start-arkose',
                    onReady: registrationFormEnforcement.onReady,
                    onCompleted: registrationFormEnforcement.onComplete,
                    onHide: registrationFormEnforcement.onHide
                });
            };
        },

        onReady: function onReady() {
            twilio.registrationForm.ready();

            twilio.registrationForm.validate();
            var startArkose = function startArkose() {
                $startArkose.trigger('click');
            };
            twilio.registrationForm.registerHandlers(startArkose);
        },

        onComplete: function onComplete(response) {
            twilio.registrationForm.postData({ captchaToken: response.token });
        },

        onHide: function onHide(response) {
            if (!response.completed) {
                twilio.registrationForm.reset();
            }
        }
    };

    if (isArkoseOn) {
        registrationFormEnforcement.setup();
        arkoseBabysitter();
    } else {
        twilio.registrationForm.ready();
        twilio.registrationForm.validate();
        twilio.registrationForm.registerHandlers();
    }
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

  var WRITE_KEY_DEV = 'GzxLVReekc5XLtIoZHW0VzUCJruriUe9';
  var WRITE_KEY_STAGE = '2ETwUyTygB2mj5QNUvr6Fcfn3DzEKx4X';
  var WRITE_KEY_PROD = 'vQNeEUkC3ieQ65ljR7oeYzybrpVBx53o';
  var SNIPPET_VERSION = '4.15.2';
  var ENV_PROD = 'prod';
  var ENV_STAGE = 'stage';
  var ENV_DEV = 'dev';
  var ENV_LOCAL = 'local';

  var getWriteKey = function getWriteKey() {
    var environment = window.twilio.environment || ENV_STAGE;
    switch (environment) {
      case ENV_PROD:
        return WRITE_KEY_PROD;
      case ENV_DEV:
        return WRITE_KEY_DEV;
      case ENV_LOCAL:
        return WRITE_KEY_DEV;
      default:
        return WRITE_KEY_STAGE;
    }
  };

  // Segment Analytics Js
  // Create a queue, but don't obliterate an existing one!
  var analytics = window.analytics = window.analytics || [];
  // If the real analytics.js is already on the page return.
  if (analytics.initialize) return;
  // If the snippet was invoked already show an error.
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.');
    }
    return;
  }
  // Invoked flag, to make sure the snippet
  // is never invoked twice.
  analytics.invoked = true;
  // A list of the methods in Analytics.js to stub.
  analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware'];
  // Define a factory to create stubs. These are placeholders
  // for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is
  // stored as the first argument, so we can replay the data.
  analytics.factory = function (method) {
    return function () {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  // For each of our methods, generate a queueing stub.
  for (var i = 0; i < analytics.methods.length; i++) {
    var key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  // Define a method to load Analytics.js from our CDN,
  // and that will be sure to only ever load it once.
  analytics.load = function (key, options) {
    // Create an async script element based on your key.
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
    // Insert script next to the first script element.
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  };

  var writeKey = getWriteKey();

  analytics._writeKey = writeKey;

  analytics.SNIPPET_VERSION = SNIPPET_VERSION;

  analytics.load(writeKey);

  var accountSid = null;
  if (window.twilio.account && window.twilio.account.sid) {
    accountSid = window.twilio.account.sid;
  }

  var context = { groupId: accountSid };

  analytics.page('', '', {}, { context: context });
})();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
	jQuery.extend(jQuery.expr[':'], {
		focusable: function focusable(el, index, selector) {
			return $(el).is('input[type="text"], input[type="password"], input[type="email"], button#signup-button');
		}
	});

	function MaterialForm(selector) {
		this.el = $(selector);

		this.passwordEl = $('#Passwd');

		this.revealPasswordToggleBtn = $('.reveal-password-toggle', this.el);

		this.passwordGuidelinesMobileEl = $('.show-pw-guidelines-mobile', this.el);

		this.cardLeftEl = $('#card-left');
		this.passwordGuidelinesEl = $('#password-guidelines');
		this.passwordRequirementsEl = $('#password-requirements');
		this.cardLeftContent = null;

		this.handleInputFocus = $.proxy(this.onInputFocus, this);
		this.handleInputBlur = $.proxy(this.onInputBlur, this);
		this.handleInputChange = $.proxy(this.onInputChange, this);
		this.handleRevealPasswordToggle = $.proxy(this.revealPasswordToggle, this);
		this.handleEnterKey = $.proxy(this.onEnterKey, this);
		this.togglePasswordGuidelinesMobile = $.proxy(this.togglePasswordGuidelinesMobile, this);

		this.init();
	}

	/**
  * Selector used to identify text input elements.
  * @type {String}
  */
	MaterialForm.INPUT_SELECTOR = ['input[type="text"]', 'input[type="password"]', 'input[type="email"]'].join(', ');

	MaterialForm.prototype.init = function () {
		// Set default state for each element
		this.el.find(MaterialForm.INPUT_SELECTOR).each($.proxy(function (index, el) {
			this.updateInputState($(el));
		}, this));

		this.addEventListeners();
		this.initializeSelectize();

		setInterval(this.autofillFix, 100);
	};

	/**
  * We need to apply autofill fix for the form to avoid situation when autofilled data
  * is covered with form placeholders (actually our placeholders are css modified labels).
  */
	MaterialForm.prototype.autofillFix = function () {
		var inputs = $('.pristine ' + MaterialForm.INPUT_SELECTOR);

		inputs.each(function () {
			var currentInput = $(this);
			var isCurrentInputEmpty = currentInput.val() === '';
			var isWebkitBrowser = 'webkitLineBreak' in document.documentElement.style;
			var isWebKitAutofilled = false;

			if (isCurrentInputEmpty && isWebkitBrowser) {
				isWebKitAutofilled = currentInput.is(':-webkit-autofill');
			}

			if (!isCurrentInputEmpty || isWebKitAutofilled) {
				currentInput.closest('.pristine').removeClass('pristine');
			}
		});
	};

	MaterialForm.prototype.addEventListeners = function () {
		this.el.on('focus', MaterialForm.INPUT_SELECTOR, this.handleInputFocus);
		this.el.on('blur', MaterialForm.INPUT_SELECTOR, this.handleInputBlur);
		this.el.on('keyup', MaterialForm.INPUT_SELECTOR, this.handleInputChange);
		this.revealPasswordToggleBtn.on('mousedown touchstart', this.handleRevealPasswordToggle);
		this.revealPasswordToggleBtn.on('click', function (e) {
			return e.preventDefault();
		});
		this.el.on('keypress', 'input, select', this.handleEnterKey);
		this.passwordGuidelinesMobileEl.on('click', this.togglePasswordGuidelinesMobile);
	};

	MaterialForm.prototype.onInputFocus = function (event) {
		var el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
		el.parent().addClass('focus');

		if (el.is(this.passwordEl)) {
			this.showPasswordHelper();
		}
	};

	MaterialForm.prototype.onInputBlur = function (event) {
		var el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
		el.parent().removeClass('focus');

		if (el.is(this.passwordEl)) {
			this.hidePasswordHelper();
		}
	};

	MaterialForm.prototype.onInputChange = function (event) {
		var el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
	};

	MaterialForm.prototype.onEnterKey = function (event) {
		if (event.which === 13) {
			event.preventDefault();

			var focusableEls = $(':focusable');
			var index = focusableEls.index(event.currentTarget) + 1;

			if (index >= focusableEls.length) {
				index = 0;
			}

			focusableEls.eq(index).focus();
		}
	};

	MaterialForm.prototype.updateInputState = function (el) {
		if (el.val()) {
			el.parents('.material-form-group').removeClass('pristine');
		} else {
			el.parents('.material-form-group').addClass('pristine');
		}
	};

	MaterialForm.prototype.showPasswordHelper = function () {
		if (this.cardLeftContent === null) {
			this.cardLeftContent = this.cardLeftEl.children();
		}
		if (this.passwordRequirementsEl.length) {
			this.cardLeftEl.html(this.passwordRequirementsEl.children().clone());
		} else {
			this.cardLeftEl.html(this.passwordGuidelinesEl.children().clone());
		}
	};

	MaterialForm.prototype.hidePasswordHelper = function () {
		if (this.cardLeftContent) {
			this.cardLeftEl.html(this.cardLeftContent);
		}
	};

	MaterialForm.prototype.revealPasswordToggle = function (event) {
		event.preventDefault();

		var el = this.passwordEl;
		var btn = this.revealPasswordToggleBtn;

		if (el.attr('type') === 'password') {
			el.attr('type', 'text');
			btn.addClass('js-show').text('Hide');
		} else {
			el.attr('type', 'password');
			btn.removeClass('js-show').text('Show');
		}

		this.passwordEl.focus();

		return false;
	};

	MaterialForm.prototype.initializeSelectize = function () {
		$('.render-after-init', this.el).each(function () {
			$(this).replaceWith($(this).html());
		});

		var selectEls = this.el.find('select');

		selectEls.parents('.material-form-group').addClass('pristine');

		selectEls.selectize({
			onChange: function onChange(value) {
				this.$input.parents('.material-form-group').removeClass('pristine');
			},
			onBlur: function onBlur() {
				if (!this.getValue()) {
					this.$input.parents('.material-form-group').addClass('pristine');
				}
			},
			onDropdownOpen: function onDropdownOpen() {
				this.$input.parents('.material-form-group').removeClass('pristine');
			},
			searchField: ['text', 'value'],
			selectOnTab: true
		});
	};

	MaterialForm.prototype.togglePasswordGuidelinesMobile = function () {
		this.passwordGuidelinesEl.toggle();
	};

	$(function () {
		new MaterialForm('.material-form');
	});
})();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    var DEV_ID = 'G-RL9Y26WNW2';
    var PROD_ID = 'G-RRP8K4M4F3';

    var ENV_PROD = 'prod';

    var getId = function getId() {
        var environment = window.twilio.environment || false;
        switch (environment) {
            case ENV_PROD:
                return PROD_ID;
            default:
                return DEV_ID;
        }
    };

    /*-- Global site tag (gtag.js) - Google Analytics */
    var script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + getId();
    script.type = "text/javascript";
    script.async = true;
    script.onload = function () {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', getId());
    };
    document.head.appendChild(script);
})();

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/try-twilio.js